var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c(
            "div",
            { attrs: { id: "customToolbar" } },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.createAlertModal",
                      modifiers: { createAlertModal: true },
                    },
                  ],
                  attrs: { size: "md", variant: "outline-primary" },
                },
                [
                  _c("span", { staticClass: "fa fa-plus" }),
                  _vm._v(
                    " " + _vm._s(_vm.$t("admin.create_alert")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _c("bootstrap-table", {
            ref: "table",
            attrs: {
              columns: _vm.columns,
              data: _vm.data,
              options: _vm.options,
            },
          }),
        ],
        1
      ),
      _c("create-alert-modal", { on: { refreshTable: _vm.refreshTable } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }